import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from '../auth/guards/auth.guard';

import { PlannerDashboardType } from './enums/PlannerDashboardType.enum';
import { PlannerEditComponent } from './components/planner-edit/planner-edit.component';
import { AdvertiserDashboardComponent } from './components/advertiser-dashboard/advertiser-dashboard.component';
import { MarketDashboardComponent } from './components/market-dashboard/market-dashboard.component';
import { PlannerDashboardComponent } from './components/planner-dashboard/planner-dashboard.component'
import { AdvertiserResolver, PlannerResolver, DashboardResolver, PlannerDefaultResolver, PlannerDetailsResolver, PlannerResultResolver, InventorySourceResolver } from './services/planner-resolvers.service';
import { DashboardType } from './enums/DashboardType.enum';
import { PlanConfirmationComponent } from './components/planner-edit/components/plan-confirmation/plan-confirmation.component';

const routes: Routes = [
  {
    path: 'planner',
    children: [
      {
        path: 'new',
        component: PlannerEditComponent,
        canActivate: [AuthGuard],
        resolve: { advertiserInfo: AdvertiserResolver, defaultPlanConfigVO: PlannerDefaultResolver }
      },
      {
        path: 'edit/:plannerId',
        component: PlannerEditComponent,
        canActivate: [AuthGuard],
        resolve: { planConfigVO: PlannerResolver }
      },
      {
        path: 'edit/:plannerId/copy',
        component: PlannerEditComponent,
        canActivate: [AuthGuard],
        resolve: { planConfigVO: PlannerResolver }
      },
      {
        path: 'edit/:plannerId/details',
        component: PlanConfirmationComponent,
        canActivate: [AuthGuard],
        resolve: { planDetails: PlannerDetailsResolver }
      }
    ]
  },
  {
    path: 'market-dashboard/:marketId',
    resolve: { marketInfo: DashboardResolver },
    data: {
      dashboardType: DashboardType.MarketDashboard
    },
    children: [
      { path: '', redirectTo: 'advertiser-list', pathMatch: 'full' },
      { path: 'advertiser-list', component: MarketDashboardComponent, canActivate: [AuthGuard] }
    ]
  },
  {
    path: 'advertiser-dashboard/:advertiserId',
    resolve: { advertiserInfo: DashboardResolver },
    data: {
      dashboardType: DashboardType.AdvertiserDashboard
    },
    children: [
      { path: '', redirectTo: 'planner-list', pathMatch: 'full' },
      { path: 'planner-list', component: AdvertiserDashboardComponent, canActivate: [AuthGuard] },
      { path: 'deal-list', component: AdvertiserDashboardComponent, canActivate: [AuthGuard], resolve: { currentInventorySources: InventorySourceResolver } }
    ]
  },
  {
    path: 'planner-dashboard/:plannerId',
    resolve: {
      planDetails: DashboardResolver,
      planResult: PlannerResultResolver
    },
    data: {
      dashboardType: DashboardType.PlannerDashboard
    },
    children: [
      { path: '', redirectTo: PlannerDashboardType.DigitalVideo, pathMatch: 'full' },
      { path: PlannerDashboardType.DigitalVideo, component: PlannerDashboardComponent, canActivate: [AuthGuard] },
      { path: PlannerDashboardType.IOPreview, component: PlannerDashboardComponent, canActivate: [AuthGuard] }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [
    DashboardResolver,
    AdvertiserResolver,
    PlannerResolver,
    PlannerDefaultResolver,
    PlannerDetailsResolver,
    PlannerResultResolver,
    InventorySourceResolver
  ]
})
export class PlannerRoutingModule { }
